import { render, staticRenderFns } from "./AddressInfoDia.vue?vue&type=template&id=52c3d3ec&scoped=true"
import script from "./AddressInfoDia.vue?vue&type=script&lang=js"
export * from "./AddressInfoDia.vue?vue&type=script&lang=js"
import style0 from "./AddressInfoDia.vue?vue&type=style&index=0&id=52c3d3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3d3ec",
  null
  
)

export default component.exports